import { getInvitedPrograms, getInvitedContentPrograms } from 'app/crud/editorialPrograms.crud';
import { ApiRequestError, ensureOk } from 'app/services/apiResponse.service';

// Devuelve null cuando la comprobación se cancela: el boundary la descarta sin cerrar la vista.
async function readInvitedCourses(request, context) {
  let response;

  try {
    response = await ensureOk(request, context);
  } catch (error) {
    if (error instanceof ApiRequestError && error.cancelled) return null;
    throw new Error('EDITORIAL_PROGRAM_ACCESS_UNAVAILABLE');
  }

  const courses = response.data?.data?.courses;
  if (!Array.isArray(courses)) throw new Error('EDITORIAL_PROGRAM_ACCESS_UNAVAILABLE');
  return courses;
}

export async function canOpenEditorialProgram(programGuid, signal) {
  const courses = await readInvitedCourses(getInvitedPrograms({ guid: programGuid, pageSize: 1 }, signal), 'canOpenEditorialProgram');
  return courses === null ? null : courses.some((program) => program.guid === programGuid);
}

export async function canOpenEditorialContent(contentGuid, signal) {
  const courses = await readInvitedCourses(getInvitedContentPrograms(contentGuid, signal), 'canOpenEditorialContent');
  return courses === null ? null : courses.length > 0;
}
